// extracted by css-extract-rspack-plugin
var _1 = "YHv2Hi3f1l46QnPI";
var _2 = "voCNyL5MyofFnGpJ";
var _3 = "B1Ks5yNOcaco1UgP";
var _4 = "B1Ks5yNOcaco1UgP";
var _5 = "ZmV1MnrWd60gLoyJ";
var _6 = "PJAmGTYcJc76h2p6";
var _7 = "PJAmGTYcJc76h2p6";
export { _1 as "bullets", _2 as "list", _3 as "match-summary-container", _4 as "matchSummaryContainer", _5 as "title", _6 as "variant-b", _7 as "variantB" }
